import React from 'react'
import { injectIntl } from 'react-intl';
import { useStaticQuery, graphql, Link } from "gatsby"

import NextIcon from "../../../assets/next.svg"

import * as S from './Products.styled'
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import generateLink from '../../../utils/generateLink';

const Products = ({ intl, ...props }) => {
  const images = useStaticQuery(graphql`
    query {
      dash: file(relativePath: { eq: "dash.jpg" }) {
        childImageSharp {
          fixed(width: 600) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      receipt: file(relativePath: { eq: "receipt.png" }) {
        childImageSharp {
          fixed(width: 180) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      banks: file(relativePath: { eq: "banks.png" }) {
        childImageSharp {
          fixed(width: 390) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      kyc: file(relativePath: { eq: "kyc.png" }) {
        childImageSharp {
          fixed(width: 150) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <div style={{ backgroundColor: '#101010' }}>
      <S.Products id="section-products">
        <div className="container">
          <div className="title">{intl.messages.products.title}</div>

          <React.Fragment>
            {intl.locale !== 'en' && <div className="subtitle" style={{ marginBottom: 20 }}>{intl.messages.products.title2}</div>}
            <div className="grid-products">
              <div className="gd-banktransfer">
                <div className="item item--without-margin item--transfer">
                  <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.bank_transfer.title }} />
                  <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.bank_transfer.text }} />
                  {/* <div className="item__image" style={{ backgroundImage: `url(https://wepayout.co/static/6a790d7cc60323d021cff0e90e1252e9/1d98e/banks.png)` }}></div> */}
                  <div className="item__image" style={{ backgroundImage: `url(${images.banks.childImageSharp.fixed.src})` }}></div>
                  {intl.locale !== 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/transferencia-bancaria-via-pix/'} aria-label={intl.messages.products.grid.bank_transfer.link_text}><button>{intl.messages.products.grid.bank_transfer.link_text} <NextIcon /></button></Link>
                  </div>}
                  {intl.locale === 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/remittance-inbound'} aria-label={"Remittance Inbound"}><button>Remittance Inbound <NextIcon /></button></Link>
                    <Link style={{ textDecoration: 'none' }} to={'/crossborder-payments-via-pix-or-traditional-bank-transfer'} aria-label={intl.messages.products.grid.bank_transfer.link_text}><button>{intl.messages.products.grid.bank_transfer.link_text} <NextIcon /></button></Link>
                  </div>}
                </div>
              </div>
              <div className="gd-pix">
                <div className="item item--without-margin" style={{ height: '100%' }}>
                  <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.pix.title }} />
                  <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.pix.text }} />
                  {intl.locale !== 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/emissao-de-boletos/'} aria-label={intl.messages.products.grid.pix.link_text}><button>{intl.messages.products.grid.pix.link_text} <NextIcon /></button></Link>
                  </div>}
                  {intl.locale === 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/instant-billing-collection'} aria-label={intl.messages.products.grid.pix.link_text}><button>{intl.messages.products.grid.pix.link_text} <NextIcon /></button></Link>
                  </div>}
                </div>
              </div>
              <div className="gd-manage">
                <div className="item item--without-margin" style={{ height: '100%' }}>
                  <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.manage.title }} />
                  <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.manage.text }} />
                  {intl.locale !== 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/visibilidade-dos-pagamentos'} aria-label={intl.messages.products.grid.manage.link_text}><button>{intl.messages.products.grid.manage.link_text} <NextIcon /></button></Link>
                  </div>}
                  {intl.locale === 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/dashboard'} aria-label={intl.messages.products.grid.manage.link_text}><button>{intl.messages.products.grid.manage.link_text} <NextIcon /></button></Link>
                  </div>}
                </div>
              </div>
              <div className="gd-improvements">
                <div className="item item--without-margin" style={{ height: '100%' }}>
                  <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.improvements.title }} />
                  <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.improvements.text }} />
                  {intl.locale !== 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/validador-de-dados-bancarios/'} aria-label={intl.messages.products.grid.improvements.link_text}><button>{intl.messages.products.grid.improvements.link_text} <NextIcon /></button></Link>
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/pagamento-de-reembolsos'} aria-label={intl.messages.products.grid.improvements.link_text_refund}><button>{intl.messages.products.grid.improvements.link_text_refund} <NextIcon /></button></Link>
                  </div>}
                  {intl.locale === 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/bank-data-validation'} aria-label={intl.messages.products.grid.improvements.link_text}><button>{intl.messages.products.grid.improvements.link_text} <NextIcon /></button></Link>
                  </div>}
                </div>
              </div>
            </div>
          </React.Fragment>
          {
          // intl.locale === 'en'
          //   ? (
          //       <React.Fragment>
          //         <div className="subtitle" style={{ marginBottom: 20 }}>{intl.messages.products.title2}</div>
          //         <div className="grid-products">
          //           <div className="gd-banktransfer">
          //             <div className="item item--without-margin item--transfer">
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.bank_transfer.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.bank_transfer.text }} />
          //               {/* <div className="item__image" style={{ backgroundImage: `url(https://wepayout.co/static/6a790d7cc60323d021cff0e90e1252e9/1d98e/banks.png)` }}></div> */}
          //               <div className="item__image" style={{ backgroundImage: `url(${images.banks.childImageSharp.fixed.src})` }}></div>
          //               {intl.locale !== 'en' && <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/transferencia-bancaria/'} aria-label={intl.messages.products.grid.discover}><button>{intl.messages.products.grid.discover} <NextIcon /></button></Link>
          //               </div>}
          //             </div>
          //           </div>
          //           <div className="gd-pix">
          //             <div className="item item--without-margin" style={{ height: '100%' }}>
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.pix.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.pix.text }} />
          //               {intl.locale !== 'en' && <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/transferencia-bancaria-via-pix/'} aria-label={intl.messages.products.grid.discover}><button>{intl.messages.products.grid.discover} <NextIcon /></button></Link>
          //               </div>}
          //             </div>
          //           </div>
          //           <div className="gd-manage">
          //             <div className="item item--without-margin" style={{ height: '100%' }}>
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.manage.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.manage.text }} />
          //               {/* {intl.locale !== 'en' && <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/emissao-de-boletos/'} aria-label={intl.messages.products.grid.discover}><button>{intl.messages.products.grid.discover} <NextIcon /></button></Link>
          //               </div>} */}
          //             </div>
          //           </div>
          //           <div className="gd-improvements">
          //             <div className="item item--without-margin" style={{ height: '100%' }}>
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.improvements.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.improvements.text }} />
          //               {intl.locale !== 'en' && <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/validador-de-dados-bancarios/'} aria-label={intl.messages.products.grid.discover}><button>{intl.messages.products.grid.discover} <NextIcon /></button></Link>
          //               </div>}
          //             </div>
          //           </div>
          //         </div>
          //       </React.Fragment>
          //     )
          //   : (
          //       <React.Fragment>
          //         <div className="grid-products-br">
          //           <div className="gd-banktransfer">
          //             <div className="item item--without-margin item--transfer" style={{ height: '100%' }}>
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.bank_transfer.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.bank_transfer.text }} />
          //               <div className="item__image" style={{ backgroundImage: `url(https://wepayout.co/static/6a790d7cc60323d021cff0e90e1252e9/1d98e/banks.png)` }}></div>
          //               {/* <div className="item__image" style={{ backgroundImage: `url(${images.banks.childImageSharp.fixed.src})` }}></div> */}
          //               <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/transferencia-bancaria-via-pix'} aria-label={intl.messages.products.national_payments}><button>{intl.messages.products.national_payments} <NextIcon /></button></Link>
          //                 <AnchorLink style={{ textDecoration: 'none' }} to={generateLink({ link: '/clientes#crossborder', locale: intl.locale })}><button style={{ marginTop: 10 }}>{intl.messages.products.crossborder_payments} <NextIcon /></button></AnchorLink>
          //                 <AnchorLink style={{ textDecoration: 'none' }} to={generateLink({ link: '/clientes#remittance', locale: intl.locale })}><button style={{ marginTop: 10 }}>{intl.messages.products.remittance_payments} <NextIcon /></button></AnchorLink>
          //               </div>
          //             </div>
          //           </div>
          //           <div className="gd-pix">
          //             <div className="item item--without-margin" style={{ height: '100%' }}>
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.pix.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.pix.text }} />
          //               <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/emissao-de-boletos'} aria-label={intl.messages.products.payin}><button>{intl.messages.products.payin} <NextIcon /></button></Link>
          //               </div>
          //             </div>
          //           </div>
          //           <div className="gd-improvements">
          //             <div className="item item--without-margin" style={{ height: '100%' }}>
          //               <h3 className="item__title" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.improvements.title }} />
          //               <div className="item__text" dangerouslySetInnerHTML={{ __html: intl.messages.products.grid.improvements.text }} />
          //               <div className="item__links">
          //                 <Link style={{ textDecoration: 'none' }} to={'/pt-br/validador-de-dados-bancarios/'} aria-label={intl.messages.products.dq}><button>{intl.messages.products.dq} <NextIcon /></button></Link>
          //                 <Link style={{ textDecoration: 'none', marginTop: 10 }} to={'/pt-br/validador-de-dados-bancarios/'} aria-label={intl.messages.products.discover_dq}><button>{intl.messages.products.discover_dq} <NextIcon /></button></Link>
          //               </div>
          //             </div>
          //           </div>
          //         </div>
          //       </React.Fragment>
              // )
              }
          
          
          {/* <div className="grid">
            <div className="grid__column grid__column-1">
              
              <div className="item item--transfer">
                <h3 className="item__title">{intl.messages.products.transfer.title}</h3>
                <div className="item__text">{Object.keys(intl.messages.products.transfer.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.transfer.text[index] }} />)}</div>
                <div className="item__image" style={{ backgroundImage: `url(${images.banks.childImageSharp.fixed.src})` }}></div>
                {intl.locale !== 'en' && <div className="item__links">
                  <Link style={{ textDecoration: 'none' }} to={'/pt-br/transferencia-bancaria-via-pix/'} aria-label={intl.messages.products.discover_product}><button>{intl.messages.products.discover_product} <NextIcon /></button></Link>
                </div>}
              </div>

              <div className="grid__column grid__column-1-inside">
                <div className="item">
                  <h3 className="item__title">{intl.messages.products.cobrancaboletopix.title}</h3>
                  <div className="item__text">{Object.keys(intl.messages.products.cobrancaboletopix.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.cobrancaboletopix.text[index] }} />)}</div>
                  {intl.locale !== 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/emissao-de-boletos/'} aria-label={intl.messages.products.discover_product}><button>{intl.messages.products.discover_product} <NextIcon /></button></Link>
                  </div>}
                </div>

                <div className="item">
                  <h3 className="item__title">{intl.messages.products.dataqualification.title}</h3>
                  <div className="item__text">{Object.keys(intl.messages.products.dataqualification.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.dataqualification.text[index] }} />)}</div>
                  {intl.locale !== 'en' && <div className="item__links">
                    <Link style={{ textDecoration: 'none' }} to={'/pt-br/validador-de-dados-bancarios/'} aria-label={intl.messages.products.discover_product}><button>{intl.messages.products.discover_product} <NextIcon /></button></Link>
                  </div>}
                </div>

              </div>

            </div>
            <div className="grid__column grid__column-2">
              
              <div className="item item--kyc">
                <h3 className="item__title">{intl.messages.products.wallet.title}</h3>
                <div className="item__text">{Object.keys(intl.messages.products.wallet.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.wallet.text[index] }} />)}</div>
                <div className="item__links">
                  {intl.locale !== 'en' && <a style={{ textDecoration: 'none' }} href={'https://ajuda.wepayout.com.br/'} aria-label={intl.messages.products.helpcenter} target="_blank" rel="noreferrer"><button>{intl.messages.products.helpcenter} <NextIcon /></button></a>}
                  <button>{intl.messages.products.wallet.download} <NextIcon /></button>
                </div>
                <div className="item__image" style={{ backgroundImage: `url(${images.kyc.childImageSharp.fixed.src})` }}></div>
              </div>

              <div className="item">
                <h3 className="item__title">{intl.messages.products.cashpickup.title}</h3>
                <div className="item__text">{Object.keys(intl.messages.products.cashpickup.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.cashpickup.text[index] }} />)}</div>
              </div>

            </div>
          </div> */}


          <div className="subtitle">{intl.messages.products.subtitle}</div>
          {/* <div className="subtitle">{intl.messages.products.subtitle_main}</div> */}
          {/* <div className="subtitle_2">{intl.messages.products.subtitle}</div> */}

          <div className="grid">
            <div className="grid__column grid__column-3">
              <div className="item item--dash">
              {/* <div className="item item--dash" style={{ backgroundImage: `url(${images.dash.childImageSharp.fixed.src})` }}> */}
                <h3 className="item__title">{intl.messages.products.dashboard.title}</h3>
                {/* <div className="item__text">{Object.keys(intl.messages.products.dashboard.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.dashboard.text[index] }} />)}</div> */}
                <ul className="item__list">{Object.keys(intl.messages.products.dashboard.list).map(index => <li key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.dashboard.list[index] }} />)}</ul>
                <div className="item__links">
                  <AnchorLink to={generateLink({ link: '/#section-contact', locale: intl.locale })}><button>{intl.messages.products.dashboard.demo} <NextIcon /></button></AnchorLink>
                </div>
              </div>
            </div>
            <div className="grid__column grid__column-4">

              {/* <div className="item item--receipt">
                <h3 className="item__title">{intl.messages.products.receipt.title}</h3>
                <div className="item__text">{Object.keys(intl.messages.products.receipt.text).map(index => <p key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.receipt.text[index] }} />)}</div>
                <div className="item__image" style={{ backgroundImage: `url(${images.receipt.childImageSharp.fixed.src})` }}></div>
              </div> */}

              <div className="item item--conciliation">
                <h3 className="item__title">{intl.messages.products.conciliation.title}</h3>
                <div className="item__text">{Object.keys(intl.messages.products.conciliation.text).map(index => <p key={index} style={{ marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: intl.messages.products.conciliation.text[index] }} />)}</div>
                <ul className="item__list">{Object.keys(intl.messages.products.conciliation.list).map(index => <li key={index} dangerouslySetInnerHTML={{ __html: intl.messages.products.conciliation.list[index] }} />)}</ul>
                {/* <div className="item__links">
                  <Link to={generateLink({ link: '/blog', locale: intl.locale })}><button>{intl.messages.products.conciliation.readmore} <NextIcon /></button></Link>
                </div> */}
              </div>

            </div>
          </div>

        </div>
      </S.Products>

      
    </div>
  )
}

export default injectIntl(Products);